import estyled from '@signal/theme/emotion'
import {
  getSpacingSelector,
  paletteTextImageFilterSelector
} from '@signal/theme/selectors'

export const Image = estyled.img`
  box-sizing: border-box;
  object-fit: contain;
  margin-top: 1px;
  padding: ${getSpacingSelector(2)}px 0;
  filter: ${paletteTextImageFilterSelector};
`
